import React from "react";
import propTypes from "prop-types";
import Common from "../../constants/common";
import "./style.css";

const Filler = props => (
    <div
        className="fillerBarFromCreateBudget"
        style={{
            width:
                parseFloat(props.width) === 100
                    ? `${parseFloat(props.width)}%`
                    : `${parseFloat(props.width) + 1}%`
        }}
    ></div>
);

const FillerForReports = props => (
    <div className="fillerBarReports">
        <div
            className={
                props.type === "fromReportHeader"
                    ? "approvedAmount"
                    : "approvedAmount isFromDialogViewBorder"
            }
            style={{
                width: `${props.approvedWidth}%`,
                borderRadius: props.approvedWidth >= 100 ? "10px" : "10px 0px 0px 10px"
            }}
        ></div>
        <div
            className="pendingAmount"
            style={{
                width: `${props.pendingWidth}%`,
                borderRadius:
                    props.pendingWidth <= 100 && props.pendingWidth >= 1
                        ? props.approvedWidth <= 100 && props.approvedWidth >= 1
                            ? "0px"
                            : "10px 0px 0px 10px"
                        : "10px 0px 0px 10px"
            }}
        ></div>
        <div
            className={
                props.type === "fromReportHeader"
                    ? "avilableAmount"
                    : "avilableAmount isFromDialogViewBorder"
            }
            style={{
                width: `${props.availableWidth}%`,
                borderRadius:
                    props.availableWidth >= 100
                        ? props.availableWidth == 100 && props.pendingWidth == 1
                            ? "0px 10px 10px 0px"
                            : "10px"
                        : "0px 10px 10px 0px"
            }}
        ></div>
    </div>
);

const FillerForOverAllStates = props => (
    <div className="fillerBarReports" style={{ height: "10px" }}>
        <div
            className={
                props.type === "fromReportHeader"
                    ? "approvedAmount"
                    : "approvedAmount isFromDialogViewBorder"
            }
            style={{
                width: `${props.approvedWidth}%`,
                borderRadius: props.approvedWidth >= 100 ? "10px" : "10px 0px 0px 10px"
            }}
        ></div>
        <div
            className="pendingAmount"
            style={{
                width: `${props.pendingWidth}%`,
                borderRadius:
                    props.pendingWidth <= 100 && props.pendingWidth >= 1
                        ? props.approvedWidth <= 100 && props.approvedWidth >= 1
                            ? "0px"
                            : "10px 0px 0px 10px"
                        : "10px 0px 0px 10px"
            }}
        ></div>
        <div
            className={
                props.type === "fromReportHeader"
                    ? "avilableAmount"
                    : "avilableAmount isFromDialogViewBorder"
            }
            style={{
                width: `${props.availableWidth}%`,
                borderRadius:
                    props.availableWidth >= 100
                        ? props.availableWidth == 100 && props.pendingWidth == 1
                            ? "0px 10px 10px 0px"
                            : "10px"
                        : "0px 10px 10px 0px"
            }}
        ></div>
    </div>
);
function CalculateFillerWidth(props) {
    const curr = props.allocatedAmount;
    const total = props.allocatedAmount + props.availableAmount;
    let percentCal = 0;
    let fillerLength = 0;
    let calculatedPixels = "0px";
    if (curr === 0) {
        percentCal = 0;
    } else {
        percentCal = curr / total;
    }
    fillerLength = percentCal * 100;
    if (fillerLength >= 100) {
        fillerLength = 100;
    }
    calculatedPixels = `${Math.ceil(fillerLength)}`;
    return calculatedPixels;
}

function CalculateFillerWidthForReports(props, tempAmt) {
    const curr = tempAmt;
    const total = props.availableAmt + props.pendingAmt + props.approvedAmt;
    let percentCal = 0;
    let fillerLength = 0;
    let calculatedPixels = "0px";
    if (curr === 0) {
        percentCal = 0;
    } else {
        percentCal = curr / total;
    }
    fillerLength = percentCal * 100;
    if (fillerLength >= 100) {
        fillerLength = 100;
    }
    calculatedPixels = `${Math.ceil(fillerLength)}`;
    return calculatedPixels;
}
function viewPreviousBdgt(props) {
    props.viewPreviousBdgt(true);
}
const renderProgress = props => {
    const calulateWidth = CalculateFillerWidth(props);
    let percentApprovedAmt = props.totalAmt
        ? ((props.approvedAmt / props.totalAmt) * 100).toFixed(2)
        : 0;
    let percentPendingAmt = props.totalAmt
        ? ((props.pendingAmt / props.totalAmt) * 100).toFixed(2)
        : 0;
    let percentAvailableAmt = props.totalAmt
        ? ((props.availableAmt / props.totalAmt) * 100).toFixed(2)
        : 0;

    switch (props.type) {
        case "fromReportHeader":
            return (
                <div className="barParent">
                    <div className="barInfoDiv">
                        <div className="leftInfoDiv">
                            <span className="fixLeftSide lable-color">Approved expenses:</span>
                            <div className="fixLeftSide">
                                <span className="variablePerContent">
                                    {" "}
                                    {props.currencyCode} {props.approvedAmt.toFixed(2)}
                                </span>
                                <span className="variablePerContent"> ({percentApprovedAmt}%)</span>
                            </div>
                        </div>
                        <div className="middleInfoDiv">
                            <span className="fixPerContent lable-color">
                                Pending for approval:{" "}
                            </span>
                            <div>
                                <span className="variablePerContent">
                                    {props.currencyCode} {props.pendingAmt.toFixed(2)}
                                </span>
                                <span className="variablePerContent"> ({percentPendingAmt}%)</span>
                            </div>
                        </div>
                        <div className="rightInfoDiv">
                            <span className="fixPerContent lable-color">
                                {`Available for ${Common._flexiDynamicData(
                                    "keyWord_0",
                                    "expense"
                                )}`}
                                :{" "}
                            </span>
                            <div>
                                <span className="variablePerContent">
                                    {props.currencyCode} {props.availableAmt.toFixed(2)}
                                </span>
                                <span className="variablePerContent">
                                    {" "}
                                    ({percentAvailableAmt}%)
                                </span>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-around" }}>
                        <div className="completionBar" style={props.withOutBorder}>
                            <FillerForReports
                                pendingWidth={CalculateFillerWidthForReports(
                                    props,
                                    props.pendingAmt
                                )}
                                availableWidth={CalculateFillerWidthForReports(
                                    props,
                                    props.availableAmt
                                )}
                                approvedWidth={CalculateFillerWidthForReports(
                                    props,
                                    props.approvedAmt
                                )}
                            />
                            <div
                                className="fillerBar nonFillerBar"
                                style={{
                                    width: `${100 - parseFloat(calulateWidth)}%`,
                                    float: "right"
                                }}
                            ></div>
                        </div>
                        {props.drawFor === "subBudget" ? null : (
                            <div className="complitionLeftBar" style={{ right: 0 }}>
                                <div className="lable-color">{props.totalBudgetLable}:</div>
                                <div style={{ fontWeight: "bold" }}>
                                    {props.currencyCode}{" "}
                                    {(
                                        props.approvedAmt +
                                        props.pendingAmt +
                                        props.availableAmt
                                    ).toFixed(2)}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            );
        case "fromCreateBudget":
            return (
                <div className="barParent">
                    {/* <div className={"viewPAllcation"}>
                        <span onClick={() => viewPreviousBdgt(props)}>
                            <span>View previous allocations</span>
                                <img
                                    src="/assets/images/arrowbutton.svg"
                                    style={{ cursor: "pointer",
                                    height: '15px',
                                    width: '15px' }}
                                />
                        </span>
                     </div> */}
                    <div className="barInfoDiv">
                        <div className="leftInfoDiv">
                            <span className="fixLeftSide lable-color">Allocated Amount:</span>
                            <span className="variableLeftSide">
                                {" "}
                                {props.currencyCode} {parseFloat(props.allocatedAmount).toFixed(2)}
                            </span>
                        </div>
                        <div className="rightInfoDiv">
                            <span className="fixPerContent lable-color">
                                Available for allocation:{" "}
                            </span>
                            <span className="variablePerContent" style={{ color: "#d4abce" }}>
                                {props.currencyCode} {parseFloat(props.availableAmount).toFixed(2)}
                            </span>
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-around" }}>
                        <div className="completionBar">
                            <Filler width={calulateWidth} />
                            <div
                                className="fillerBarFromCreateBudget nonFillerBarFromCreateBudget"
                                style={{
                                    width: `${100 - parseFloat(calulateWidth)}%`,
                                    float: "right"
                                }}
                            ></div>
                        </div>
                        <div className="complitionLeftBar">
                            <div className="lable-color">Total Budget:</div>
                            <div style={{ fontWeight: "bold" }}>
                                {props.currencyCode}{" "}
                                {(
                                    parseFloat(props.allocatedAmount) +
                                    parseFloat(props.availableAmount)
                                ).toFixed(2)}{" "}
                            </div>
                        </div>
                    </div>
                </div>
            );
        case "overAllState":
            return (
                <FillerForOverAllStates
                    pendingWidth={CalculateFillerWidthForReports(props, props.pendingAmt)}
                    availableWidth={CalculateFillerWidthForReports(props, props.availableAmt)}
                    approvedWidth={CalculateFillerWidthForReports(props, props.approvedAmt)}
                />
            );
        case "subBudget":
            return (
                <div className="barParent">
                    <div className="barInfoDiv">
                        <div className="leftInfoDiv">
                            <span className="fixLeftSide lable-color">Approved:</span>
                            <span className="variablePerContent">
                                {" "}
                                {props.approvedAmt}&nbsp;&nbsp;
                            </span>
                        </div>
                        <div className="middleInfoDiv">
                            <span className="fixPerContent lable-color">Pending: </span>
                            <span className="variablePerContent">
                                {props.pendingAmt} &nbsp;&nbsp;
                            </span>
                        </div>
                        <div className="rightInfoDiv">
                            <span className="fixPerContent lable-color">Available: </span>
                            <span className="variablePerContent">
                                {props.availableAmt} &nbsp;&nbsp;
                            </span>
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-around" }}>
                        &nbsp;
                        <div
                            className="completionBar"
                            style={Object.assign(props.withOutBorder, {
                                width: "100%",
                                height: "14px",
                                position: "relative",
                                left: "9px"
                            })}
                        >
                            <FillerForReports
                                pendingWidth={CalculateFillerWidthForReports(
                                    props,
                                    props.pendingAmt
                                )}
                                availableWidth={CalculateFillerWidthForReports(
                                    props,
                                    props.availableAmt
                                )}
                                approvedWidth={CalculateFillerWidthForReports(
                                    props,
                                    props.approvedAmt
                                )}
                            />
                            <div
                                className="fillerBar nonFillerBar"
                                style={{
                                    width: `${100 - parseFloat(calulateWidth)}%`,
                                    float: "right"
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            );
        default:
            return (
                <div className="isFromDialogViewBar">
                    <FillerForReports
                        pendingWidth={CalculateFillerWidthForReports(props, props.pendingAmt)}
                        availableWidth={CalculateFillerWidthForReports(props, props.availableAmt)}
                        approvedWidth={CalculateFillerWidthForReports(props, props.approvedAmt)}
                    />
                </div>
            );
    }
};

const ProgessBar = props => {
    return renderProgress(props);
};

ProgessBar.defaultProp = {
    allocatedAmount: 0,
    availableAmount: 0,
    availableAmt: 0,
    pendingAmt: 0,
    approvedAmt: 0,
    currencyCode: "INR",
    withOutBorder: {}
};

Filler.propTypes = {
    width: propTypes.string
};

export default ProgessBar;
